import { render, staticRenderFns } from "./UserPlatforms.vue?vue&type=template&id=6adac943"
import script from "./UserPlatforms.vue?vue&type=script&lang=js"
export * from "./UserPlatforms.vue?vue&type=script&lang=js"
import style0 from "./UserPlatforms.vue?vue&type=style&index=0&id=6adac943&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports